import { render } from "./user_info.vue?vue&type=template&id=79aedf24&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"

import "./user_info.vue?vue&type=style&index=0&id=79aedf24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79aedf24"]])

export default __exports__